import React, { useState, useContext, useRef } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import swal from "sweetalert";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { useInput } from "./useInput";
import UserService from "./UserService";
import LoadingButton from "../common/LoadingButton";

import { EnterpriseNameContext } from "../../context/EnterpriseContext";

// import { FormHandles } from '@unform/core';
// import { Form } from '@unform/web';

function CreateUser(props) {
  const levelForm = [
    "Administrador",
    "Corpo Técnico",
    "Executante",
    "Requisitante",
    "Amoxarife",
    "Ferramenteiro",
    // "Amoxarife e Ferramenteiro",
  ];

  const { enterpriseName } = useContext(EnterpriseNameContext);
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const {
    value: first_name,
    bind: bindfirst_name,
    setValue: setFisrt_name,
  } = useInput();
  const { value: last_name } = useInput("");
  const { value: area } = useInput("");
  const { value: level, bind: bindlevel, setValue: setLevel } = useInput();
  const { value: email, bind: bindemail, setValue: setEmail } = useInput("");
  const {
    value: custohh,
    bind: bindcustohh,
    setValue: setCustohh,
  } = useInput();
  const { value: phone, bind: bindphone, setValue: setPhone } = useInput("");

  //YUP IN HAND
  const [requireName, setRequireName] = useState(false);
  const [messageRequireName, setMessageRequireName] = useState("");

  const [requireFunction, setRequireFunction] = useState(false);
  const [messageRequireFunction, setMessageRequireFunction] = useState("");

  const [requireEmail, setRequireEmail] = useState(false);
  const [messageRequireEmail, setMessageRequireEmail] = useState("");

  const formRef = useRef(null);

  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    UserService.getUsers({ email: email })
      .then((response) => {
        if (response.data.length > 0) {
          swal("Erro", "Email já cadastrado", "error");
        } else {
          if (first_name && email && level) {
            let users = {
              first_name: first_name,
              last_name: last_name,
              area: area,
              level: level,
              email: email?.trim(),
              phone: phone,
              empresa: enterpriseName,
            };
            return UserService.createUser(users)
              .then((res) => {
                swal(
                  "Success!",
                  "E-mail enviado para o novo usuário contendo as instruções de acesso.",
                  "success"
                ).then((value) => {
                  UserService.getUsers({ empresa: enterpriseName }).then(
                    (res) => {
                      props.setUser(res.data);
                      setModal(false);
                      setLevel(null);
                      setPhone(null);
                      setCustohh(null);
                      setEmail(null);
                      setFisrt_name(null);
                    }
                  );
                });
              })
              .catch((error) => console.error(error.response));
          }
          if (!first_name) {
            setRequireName(true);
            setMessageRequireName("O campo Nome Completo é obrigatório!");
          } else {
            setRequireName(false);
            setMessageRequireName("");
          }
          if (!level) {
            setRequireFunction(true);
            setMessageRequireFunction("O campo Função é obrigatório!");
          } else {
            setRequireFunction(false);
            setMessageRequireFunction("");
          }
          if (!email) {
            setRequireEmail(true);
            setMessageRequireEmail("O campo Email é obrigatório!");
          } else {
            setRequireEmail(false);
            setMessageRequireEmail("");
          }
        }
      })
      .catch((error) => {
      })
      .finally(() => setSubmitting(false));
    // const removeDot = custohh?.toString()?.replace(".", "");
    // const changeComma = removeDot?.replace(",", ".");
    // const converted = parseFloat(changeComma).toFixed(2);
  };

  return (
    <div>
      <Button
        color="success"
        size="sm"
        className="position-absolute top-3 right-4"
        onClick={toggle}
      >
        {" "}
        Novo Usuário{" "}
      </Button>
      <Modal isOpen={modal} toggle={toggle} className="mr-0 mt--1 mb--1 mt-5">
        <ModalHeader className="mt-3" toggle={toggle} tag="h2">
          Novo Usuário
        </ModalHeader>
        <ModalBody className="mb-1 mt--2 mb-2">
          <form ref={formRef} onSubmit={handleSubmit}>
            <div className="form-group">
              <TextField
                // required={true}
                {...bindfirst_name}
                label="Nome Completo"
                margin="normal"
                fullWidth
                variant="outlined"
                error={requireName}
                helperText={messageRequireName}
              />
            </div>

            <div className="form-group">
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={levelForm}
                // {...bindlevel}
                onChange={(e, v) => {
                  setLevel(v);
                }}
                renderInput={(params) => (
                  <TextField
                    {...bindlevel}
                    error={requireFunction}
                    variant="outlined"
                    {...params}
                    label="Função"
                    helperText={messageRequireFunction}
                  />
                )}
              />
            </div>

            {/* <div className="form-group">
              <label> Área de atuação: </label>
              <select
                class="form-control select2 select2-hidden-accessible"
                tabindex="-1"
                aria-hidden="true"
                {...bindarea}
              >
                <option value="" disabled selected>
                  Selecione uma opção
                </option>
                <option>Mecânica</option>
                <option>Elétrica</option>
                <option>Instrumentação</option>
                <option>Automação</option>
              </select>
            </div> */}

            <div className="form-group">
              <TextField
                {...bindemail}
                label="Email"
                margin="normal"
                fullWidth
                variant="outlined"
                error={requireEmail}
                helperText={messageRequireEmail}
              />
            </div>

            <div className="form-group">
              <TextField
                {...bindphone}
                label="Telefone"
                placeholder="(00) 0 0000-0000"
                margin="normal"
                fullWidth
                variant="outlined"
              />
            </div>

            {/* <div className="form-group">
              <TextField
                {...bindcustohh}
                placeholder="Custo medio da hora"
                label="Custo Hh"
                margin="normal"
                fullWidth
                variant="outlined"
              />
            </div> */}
            <ModalFooter>
              <LoadingButton type="submit" color="success" loading={submitting}>
                Criar
              </LoadingButton>{" "}
              <Button color="secondary" onClick={toggle}>
                Cancelar
              </Button>
            </ModalFooter>
          </form>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default CreateUser;
